import { Box } from "@mui/material";
import { ReactNode, useLayoutEffect, useRef, useState } from "react";

/**
 * Animates its height to follow its content: it opens from zero on mount and
 * eases whenever the content grows or shrinks (e.g. a skeleton replaced by rows).
 */
export const AnimatedHeight = ({ children }: { children: ReactNode }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const content = contentRef.current;
    if (!content) return;
    const observer = new ResizeObserver(([entry]) => setHeight(entry.contentRect.height));
    observer.observe(content);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={(theme) => ({
        height,
        overflow: "hidden",
        transition: theme.transitions.create("height", {
          duration: theme.transitions.duration.shorter,
        }),
        "@media (prefers-reduced-motion: reduce)": { transition: "none" },
      })}
    >
      <div ref={contentRef}>{children}</div>
    </Box>
  );
};
